import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import apiBaseUrl from './apiBaseUrl';
import './styles.css';

function TestFunctions() {
  const { instance, accounts } = useMsal();
  const [results, setResults] = useState('');
  const [loading, setLoading] = useState({
    reset: false,
    downloadPubs: false,
    downloadDocs: false
  });

  const authFetch = async (url, options = {}) => {
    const account = accounts[0] || instance.getActiveAccount() || instance.getAllAccounts()[0];
    if (!account) {
      throw new Error('No authenticated user available.');
    }

    const tokenResponse = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    return fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${tokenResponse.idToken}`,
      },
    });
  };

  const handleApiCall = async (endpoint, buttonType) => {
    setLoading(prev => ({ ...prev, [buttonType]: true }));
    setResults('');

    try {
      const response = await authFetch(`${apiBaseUrl}/api/${endpoint}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      if (endpoint === 'download-documents') {
        // download-documents returns text
        const textData = await response.text();
        setResults(textData || 'Download documents completed successfully');
      } else {
        // reset-publication-table and download-publications don't return data
        setResults(`${endpoint} completed successfully`);
      }
    } catch (error) {
      console.error(`Error calling ${endpoint}:`, error);
      setResults(`Error: ${error.message || 'Unknown error occurred'}`);
    } finally {
      setLoading(prev => ({ ...prev, [buttonType]: false }));
    }
  };

  return (
    <div className="test-functions-container">
      <h1>Test Functions</h1>
      <p>Use these buttons to test backend API functions:</p>
      
      <div className="button-container">
        <button
          className={`api-button ${loading.reset ? 'disabled' : ''}`}
          onClick={() => handleApiCall('reset-publication-table', 'reset')}
          disabled={loading.reset}
        >
          {loading.reset ? 'Resetting...' : 'Reset Publication Table'}
        </button>
        
        <button
          className={`api-button ${loading.downloadPubs ? 'disabled' : ''}`}
          onClick={() => handleApiCall('download-publications', 'downloadPubs')}
          disabled={loading.downloadPubs}
        >
          {loading.downloadPubs ? 'Downloading...' : 'Download Publications'}
        </button>
        
        <button
          className={`api-button ${loading.downloadDocs ? 'disabled' : ''}`}
          onClick={() => handleApiCall('download-documents', 'downloadDocs')}
          disabled={loading.downloadDocs}
        >
          {loading.downloadDocs ? 'Downloading...' : 'Download Documents'}
        </button>
      </div>

      <div>
        <h3>Execution Results:</h3>
        <div className="results-display">
          {results || 'No results yet. Click a button above to execute an API call.'}
        </div>
      </div>
    </div>
  );
}

export default TestFunctions;
